(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diet-weight-loss"] && !Shopify.designMode) return;
  try {
    
  $('.multiple-items').slick({
  infinite: true,
 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-summer"] && !Shopify.designMode) return;
  try {
    
  $('.multiple-items').slick({
  infinite: true,
 
});

  } catch(e) { console.error(e); }
})();
})();
